import Modal from "react-modal";
import { Link } from "react-router-dom";

export default function DateMealModal({
  selectedDateLabel,
  showModal,
  handleCloseModal,
  setShowDModal,
  handleMealChange,
  selectedMeal,
  handleOpenCModal,
  options,
  loading,
  emptyDateError,
  emptyMealError,
}) {
  return (
    <Modal
      isOpen={showModal}
      onRequestClose={handleCloseModal}
      contentLabel="Date Picker Modal"
      className="modal"
      overlayClassName="overlay"
    >
      <div className="modal-header">
        <h2>کجای تقویم باشه؟</h2>
        <Link to="" onClick={handleCloseModal}>
          <span className="icon-iconclose b-white heading-1"></span>
        </Link>
      </div>
      <div className="modal-body">
        <p>روز :</p>

        <input
          type="text"
          placeholder="انتخاب تاریخ"
          className="inputField"
          value={selectedDateLabel ? selectedDateLabel : ""}
          onClick={() => setShowDModal(true)} // Open the modal
          required
        />
        {emptyDateError && <p className="error">{emptyDateError}</p>}

        <div className="box32"></div>
        <p>وعده :</p>
        <select
          onChange={handleMealChange}
          value={selectedMeal}
          className="inputField"
          required
        >
          <option value="" disabled hidden className="grey-5">
            انتخاب وعده غذایی
          </option>
          {Object.keys(options).map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </select>
        {emptyMealError && <p className="error">{emptyMealError}</p>}
      </div>
      <div className="modal-footer">
        <Link
          to=""
          onClick={handleOpenCModal}
          className="fill-container radius1-5"
          disabled={loading}
        >
          {loading ? "در حال پردازش..." : "تایید"}
        </Link>
      </div>
    </Modal>
  );
}
